<template>
    <div class="popup" v-show="show">
        <div class="create bg_white">
            <Icon class="closer cursor_pointer" type="md-close" @click="show=false" size="26"/>
            <div class="title f18 bold500 txt_black87 tc">冻结原因</div>
            <div class="content">
                <textarea class="w100 h100 txt_black54 f14 bold500" v-model="statusDetail"></textarea>
            </div>
            <div class="submit tc">
                <button class="bg_E91E63 f18 bold400 txt_white tc cursor_pointer" @click="submitEvent">提交</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "create",
        data() {
            return {
                show: false,
                statusDetail: '',
                id: 0,
            }
        },
        methods: {
            init(id) {
                this.show = true;
                this.id = id;
            },
            submitEvent() {
                this.$api.put('/manage/user_status/' + this.id,{
                    status: 0,
                    status_detail: this.statusDetail
                }).then((data) => {
                    this.show = false;
                    this.$alert.success({content: '冻结成功'});
                    this.$emit('updateData')
                }).catch((error) => {
                    this.$alert.error({content: '冻结失败，请重试'});
                });
            }
        }
    }
</script>

<style scoped>
    .create {
        width: 400px;
        height: 300px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -150px 0 0 -200px;
        border-radius: 5px;
    }
    .content{
        padding: 20px 20px 0 20px;
        height: 140px;
    }
    .content>textarea{
        border: none;
    }
</style>